export default {"src":"/login-app/[GIT_HASH]/_next/static/media/chevron_right.85d0c23a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};